app.AdminDocuments =
    (function () {
        var docs = {
            Init: function () {
                app.AdminDocuments.SetCopyFunctionality();
                $(document).on("component-bind-save-mode-complete, component-save-complete",
                    function () {
                        app.AdminDocuments.SetCopyFunctionality();
                    });
            },
            SetCopyFunctionality: function () {
                $("[data-role='copy-link']").off("click keyup").on("click keyup",
                    function () {
                        $(this).closest(".input-group").find("input[type='text']").select();
                        document.execCommand("copy");
                        toastr.success("Successfully copied to clipboard.");
                    });
            }
        };
        return docs;
    }()
    );